export enum TailwindBreakpoints {
  MOBILE = '400px',
  SM = '640px',
  MD = '768px',
  LG = '1024px',
  XL = '1280px',
  XXL = '1536px',
}

export const MOBILE_VIEWPORT_QUERY = `(max-width: ${TailwindBreakpoints.MD})`;
